import * as classNames from "classnames";
import * as moment from "moment";
import * as React from "react";
import * as myClasses from "../";

import "./styles.css";

import { HTMLDivProps, Text } from "@blueprintjs/core";

export interface ITimerProps extends HTMLDivProps {
  text?: string;
  timerMessage?: string;
  timerMessageExpires?: string;
  startTime: string;
  endTime: string;
}

interface ITimerState {
  shouldCountDown?: boolean;
  displayedElapsedTime?: string;
  displayedRemainingTime?: string;
  timerMessage?: string;
  innerBarWidth: number;
  timePassed: number;
  timeRemaining: number;
}

export class Timer extends React.Component<ITimerProps, ITimerState> {
  private outerBarRef: React.RefObject<HTMLHRElement>;

  constructor(props: ITimerProps) {
    super(props);
    this.outerBarRef = React.createRef();
    this.getPassedTime = this.getPassedTime.bind(this);
    this.getOuterBarWidth = this.getOuterBarWidth.bind(this);
    this.getTimeRemaining = this.getTimeRemaining.bind(this);
    this.gettimerBarIncrement = this.gettimerBarIncrement.bind(this);

    const timePassed = this.getPassedTime();
    const displayedElapsedTime = this.formatSecondsToPassedTime(timePassed);
    const timeRemaining = this.getTimeRemaining();
    const displayedRemainingTime = this.formatSecondsToRemainingTime(
      timeRemaining
    );
    const expiredTime = this.formatSecondsToRemainingTime(this.getPassedTime());

    const { timerMessage, timerMessageExpires } = this.props;

    this.state = {
      timePassed,
      timeRemaining,
      displayedRemainingTime: timeRemaining > 0 ? displayedRemainingTime : "",
      displayedElapsedTime:
        timeRemaining > 0 ? displayedElapsedTime : timerMessageExpires,
      innerBarWidth: 0,
      timerMessage:
        timeRemaining > 0 ? timerMessage : "Active for " + expiredTime,
      shouldCountDown: timeRemaining > 0 ? true : false
    };
  }

  public componentWillReceiveProps({ timerMessageExpires }: ITimerProps) {
    if (timerMessageExpires !== undefined) {
      const displayedElapsedTime = this.formatSecondsToPassedTime(
        this.state.timePassed
      );

      this.setState({
        displayedElapsedTime:
          this.state.timeRemaining > 0
            ? displayedElapsedTime
            : timerMessageExpires
      });
    }
  }

  public componentDidMount() {
    const { timePassed, timeRemaining, shouldCountDown } = this.state;
    const { timerMessageExpires, timerMessage } = this.props;
    const outerBarWidth = this.getOuterBarWidth();
    const timerBarIncrement = this.gettimerBarIncrement(
      timePassed,
      timeRemaining,
      outerBarWidth
    );
    const innerBarWidth = this.getTimeBarWidth(timerBarIncrement, timePassed);

    this.setState(
      { innerBarWidth: Math.min(innerBarWidth / outerBarWidth * 100, 100) },
      () => {
        if (shouldCountDown) {
          const timer = setInterval(() => {
            const displayedRemainingTime = this.formatSecondsToRemainingTime(
              this.state.timeRemaining
            );
            const displayedElapsedTime = this.formatSecondsToPassedTime(
              this.state.timePassed
            );

            const expiredTime = this.formatSecondsToRemainingTime(
              this.getPassedTime()
            );

            this.setState({
              timeRemaining: this.state.timeRemaining - 1,
              timePassed: this.state.timePassed + 1,
              timerMessage:
                this.state.timeRemaining > 0
                  ? timerMessage
                  : "Active for " + expiredTime,
              displayedRemainingTime:
                this.state.timeRemaining > 0 ? displayedRemainingTime : "",
              displayedElapsedTime:
                this.state.timeRemaining > 0
                  ? displayedElapsedTime
                  : timerMessageExpires,
              innerBarWidth: Math.min(
                this.state.innerBarWidth +
                  timerBarIncrement / outerBarWidth * 100,
                100
              ),
              shouldCountDown: this.state.timeRemaining < 0 && false
            });
            if (!shouldCountDown) {
              clearInterval(timer);
            }
          }, 1000);
        }
      }
    );
  }

  public render() {
    const { className } = this.props;
    const {
      displayedRemainingTime,
      displayedElapsedTime,
      innerBarWidth,
      timerMessage
    } = this.state;

    const classes = classNames(myClasses.TIMER_CONTAINER, className);

    return (
      <div className={classes}>
        <Text className={myClasses.TIMER_BAR_TIME_ELAPSED}>
          {displayedElapsedTime}
        </Text>
        <Text className={myClasses.TIMER_BAR_TIME_REMAINING}>
          <span>{timerMessage}</span> <span> {displayedRemainingTime} </span>
        </Text>
        <div className={myClasses.TIMER_BAR}>
          <hr className={myClasses.TIMER_OUTER_BAR} ref={this.outerBarRef} />
          <hr
            className={myClasses.TIMER_INNER_BAR}
            style={{ width: innerBarWidth + "%" }}
          />
        </div>
      </div>
    );
  }

  private getPassedTime() {
    const { startTime, endTime } = this.props;
    if (startTime) {
      const unixStartTime = parseInt(startTime, 10);
      const initialDate = moment(new Date(unixStartTime * 1000));
      const unixEndTime = parseInt(endTime, 10);
      const endDate = moment(new Date(unixEndTime * 1000));
      const currentDate = moment(new Date());
      const timePassed = moment
        .duration(currentDate.diff(initialDate))
        .asSeconds();
      const maxTimePassed = moment
        .duration(endDate.diff(initialDate))
        .asSeconds();

      return timePassed > maxTimePassed ? maxTimePassed : timePassed;
    }
    return 0;
  }

  private getTimeRemaining() {
    const { endTime } = this.props;
    if (endTime) {
      const unixEndTime = parseInt(endTime, 10);
      const expiryDate = moment(new Date(unixEndTime * 1000));
      const currentDate = moment(new Date());
      const timeRemaining = moment
        .duration(expiryDate.diff(currentDate))
        .asSeconds();

      return timeRemaining > 0 ? timeRemaining : 0;
    }
    return 0;
  }

  private getOuterBarWidth() {
    if (this.outerBarRef && this.outerBarRef.current) {
      const outerBarWidth = this.outerBarRef.current.offsetWidth;
      return outerBarWidth;
    }
    return 0;
  }

  private gettimerBarIncrement(
    timePassed: number,
    timeRemaining: number,
    outerBarWidth: number
  ) {
    const totalTime = timePassed + timeRemaining;
    const timerBarIncrement = outerBarWidth / totalTime;
    return timerBarIncrement;
  }

  private getTimeBarWidth(timerBarIncrement: number, timePassed: number) {
    const innerBarWidth = timerBarIncrement * timePassed;
    return innerBarWidth;
  }

  private formatSecondsToRemainingTime(seconds: number) {
    const days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;
    const hrs = Math.floor(seconds / 3600);
    seconds -= hrs * 3600;
    const mnts = Math.floor(seconds / 60);

    let formattedTime;

    if (days > 1) {
      formattedTime = days + "d " + hrs + "h " + mnts + "m ";
    } else if (days === 1) {
      formattedTime = days + "d " + hrs + "h " + mnts + "m ";
    } else {
      formattedTime = hrs + "h " + mnts + "m ";
    }

    return formattedTime;
  }

  private formatSecondsToPassedTime(seconds: number) {
    const days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;
    let hrs = Math.floor(seconds / 3600);
    seconds -= hrs * 3600;
    const mnts = Math.floor(seconds / 60);
    seconds -= mnts * 60;
    seconds = Math.round(seconds);
    hrs = hrs + days * 24;

    const formattedTime =
      ("0" + hrs).slice(-hrs.toString().length) +
      ":" +
      ("0" + mnts).slice(-2) +
      ":" +
      ("0" + seconds).slice(-2);

    return formattedTime;
  }
}



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/timer/timer.tsx